import { render, staticRenderFns } from "./cardDetailReport.vue?vue&type=template&id=6654de7a"
import script from "./cardDetailReport.vue?vue&type=script&lang=ts"
export * from "./cardDetailReport.vue?vue&type=script&lang=ts"
import style0 from "./cardDetailReport.vue?vue&type=style&index=0&id=6654de7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports